import ltiApi from '@/services/plataforma/lti';
export default {
  async getProviderList({ commit }, { page, limit, sortBy, order, searchProvider }) {
    return ltiApi.getProviderList(page, limit, sortBy, order, searchProvider)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  async createLtiProvider({ commit }, ltiProvider) {
    return ltiApi.createLtiProvider(ltiProvider)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response.data.error));
  },
  async getLtiProvider(_, id) {
    return ltiApi.getLtiProvider(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  async editLtiProvider({ commit }, ltiProvider) {
    return ltiApi.editLtiProvider(ltiProvider)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response.data.error));
  },
  async deleteLtiProvider(_, id) {
    return ltiApi.deleteLtiProvider(id)
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  }
};
